var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ActionPoint, Behavior, RegistryCond, RegistryPointService, Stage } from './registry-point.service';
var RegistryPointComponent = /** @class */ (function (_super) {
    __extends(RegistryPointComponent, _super);
    function RegistryPointComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.behaviors = [];
        _this.stages = [];
        _this.conds = [];
        _this.items = [];
        _this.readonly = false;
        return _this;
    }
    RegistryPointComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
    };
    RegistryPointComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    RegistryPointComponent.prototype.onSubscribe = function (data) {
        if (typeof data['registry_cond'] !== 'undefined') {
            this.conds = data['registry_cond'];
        }
        if (typeof data['items'] !== 'undefined' && data['items'] instanceof Array) {
            this.behaviors = data['items'];
            this.getStage();
        }
    };
    RegistryPointComponent.prototype.getStage = function () {
        var _this = this;
        this.service.getStage().subscribe(function (items) {
            _this.stages = [];
            if (typeof items !== 'undefined') {
                _this.stages = items;
            }
            _this.getData();
        });
    };
    RegistryPointComponent.prototype.getData = function () {
        this.items = [];
        for (var _i = 0, _a = this.behaviors; _i < _a.length; _i++) {
            var behavior = _a[_i];
            var registryCond = new RegistryCond();
            for (var _b = 0, _c = this.conds; _b < _c.length; _b++) {
                var cond = _c[_b];
                var behaviorM = cond.behaviorM;
                if (typeof behaviorM !== 'undefined' && behaviorM.behavior_id === behavior.behavior_id) {
                    registryCond = JSOG.parse(JSON.stringify(cond));
                    break;
                }
            }
            if (typeof registryCond.behaviorM === 'undefined') {
                registryCond.behaviorM = Object.assign(new Behavior(), behavior);
            }
            var actionPointM = registryCond.actionPointM;
            if (typeof actionPointM !== 'undefined' && actionPointM.length > 0) {
                var stageM = actionPointM[0].stageM;
                if (!stageM) {
                    registryCond.actionPointMCommon = Object.assign(new ActionPoint(), actionPointM[0], { $type: "put" /* Put */ });
                    registryCond.actionPointM = [];
                    registryCond.is_common = true;
                }
                else {
                    registryCond.actionPointMCommon = Object.assign(new ActionPoint(), { $type: "delete" /* Delete */ });
                    registryCond.is_common = false;
                }
            }
            else {
                registryCond.actionPointMCommon = new ActionPoint();
                registryCond.actionPointM = [];
                registryCond.is_common = true;
            }
            var actionPoints = [];
            for (var _d = 0, _e = this.stages; _d < _e.length; _d++) {
                var stage = _e[_d];
                var actionPoint = new ActionPoint();
                for (var _f = 0, _g = registryCond.actionPointM; _f < _g.length; _f++) {
                    var point = _g[_f];
                    var stg = point.stageM;
                    if (typeof stg !== 'undefined' && stg.stage_id === stage.stage_id) {
                        actionPoint = JSOG.parse(JSON.stringify(point));
                        break;
                    }
                }
                if (typeof actionPoint.stageM === 'undefined') {
                    actionPoint.stageM = Object.assign(new Stage(), stage);
                }
                if (typeof actionPoint.id !== 'undefined') {
                    actionPoint.$type = "put" /* Put */;
                }
                if (registryCond.is_common) {
                    actionPoint.$type = "delete" /* Delete */;
                }
                actionPoints.push(actionPoint);
            }
            registryCond.actionPointM = actionPoints;
            this.items.push(registryCond);
        }
        this.setCompRec();
    };
    RegistryPointComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    RegistryPointComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    RegistryPointComponent.prototype.onChange = function (e, key, index, pIndex) {
        if (key === 'is_common') {
            this.items[index][key] = e.val;
            if (e.val.toString() === 'true') {
                for (var _i = 0, _a = this.items[index].actionPointM; _i < _a.length; _i++) {
                    var point = _a[_i];
                    point.point = null;
                    point.$type = "delete" /* Delete */;
                }
                var pointCommon = this.items[index].actionPointMCommon;
                if (typeof pointCommon.id !== 'undefined') {
                    pointCommon.$type = "put" /* Put */;
                }
                else {
                    pointCommon.$type = "post" /* Post */;
                }
            }
            else {
                this.items[index].actionPointMCommon.point = null;
                this.items[index].actionPointMCommon.$type = "delete" /* Delete */;
                for (var _b = 0, _c = this.items[index].actionPointM; _b < _c.length; _b++) {
                    var point = _c[_b];
                    if (typeof point.id !== 'undefined') {
                        point.$type = "put" /* Put */;
                    }
                    else {
                        point.$type = "post" /* Post */;
                    }
                }
            }
        }
        else if (key === 'pointCommon') {
            this.items[index].actionPointMCommon.point = e.val;
        }
        else if (key === 'point') {
            this.items[index].actionPointM[pIndex].point = e.val;
        }
        this.setCompRec();
    };
    RegistryPointComponent.prototype.setCompRec = function () {
        var data = [];
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            var itm = JSOG.parse(JSON.stringify(item));
            var behaviorId = itm.behaviorM.behavior_id;
            var pointCommon = itm.actionPointMCommon;
            if (pointCommon.id || pointCommon.$type === "post" /* Post */) {
                pointCommon.behavior_id = behaviorId;
                delete pointCommon.stageM;
                data.push(pointCommon);
            }
            for (var _b = 0, _c = itm.actionPointM; _b < _c.length; _b++) {
                var point = _c[_b];
                if (point.id || point.$type === "post" /* Post */) {
                    point.behavior_id = behaviorId;
                    point.stage_id = point.stageM.stage_id;
                    delete point.stageM;
                    data.push(point);
                }
            }
        }
        var items = {};
        this.action.setCompRec(this.componentName, { items: data });
    };
    RegistryPointComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'registry-point',
                    template: "<form id=\"{{ componentName }}\">\n  <ng-template ngFor let-item [ngForOf]=\"items\" let-index=\"index\">\n    <div class=\"row -mb-1\" [class.-mt-3]=\"index > 0\">\n      <div class=\"col-sm-12\">\n        <headinglabel [componentName]=\"componentName + '#' + item.behaviorM.behavior_id\" [component]=\"{title: item.behaviorM.label}\"></headinglabel>\n      </div>\n    </div>\n    <div class=\"row -mt-1\" [class.-mb-3]=\"index < items.length - 1\">\n      <div class=\"col-sm-12 -ml-3\">\n        <dl class=\"form\">\n          <dt class=\"form_dt\">\n            <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['RegistryPointComponent.label.point'], required: true}\" [msg]=\"(msg | async)\"></column-formtitle>\n          </dt>\n          <dd class=\"form_dd\">\n            <ul>\n              <li class=\"form_li\">\n                <column-radio *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                key: componentName + '.is_common-' + index,\n                controlType: 'radio',\n                required: true,\n                params: {options: [{code: true, display: (msg | async)['RegistryPointComponent.label.common']}, {code: false, display: (msg | async)['RegistryPointComponent.label.stage']}]}\n              }\" [val]=\"item['is_common']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'is_common', index, '')\"></column-radio>\n                <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n                controlType: 'radio',\n                params: {options: [{code: true, display: (msg | async)['RegistryPointComponent.label.common']}, {code: false, display: (msg | async)['RegistryPointComponent.label.stage']}]}\n              }\" [val]=\"item['is_common']\" [msg]=\"(msg | async)\"></column-formreadonly>\n              </li>\n\n              <!-- Common -->\n              <ng-template [ngIf]=\"item['is_common'].toString() === 'true'\" [ngIfElse]=\"elseBlock\">\n                <li class=\"form_li-break\"></li>\n                <li class=\"form_li\">\n                  <column-number *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                  key: componentName + '.point-' + index + '-common',\n                  controlType: 'number',\n                  required: true\n                }\" [val]=\"item.actionPointMCommon['point']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'pointCommon', index, '')\"></column-number>\n                  <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n                  controlType: 'number'\n                }\" [val]=\"item.actionPointMCommon['point']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                </li>\n              </ng-template>\n\n              <!-- Stage -->\n              <ng-template #elseBlock>\n                <ng-template ngFor let-actionPoint [ngForOf]=\"item.actionPointM\" let-pIndex=\"index\">\n                  <li class=\"form_li-break\"></li>\n                  <li class=\"form_li-break -mb-05\" [class.-mt-05]=\"pIndex > 0\">\n                    <column-formlabel [col]=\"{}\" [val]=\"actionPoint.stageM.stage_name\"></column-formlabel>\n                  </li>\n                  <li class=\"form_li\">\n                    <column-number *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                    key: componentName + '.point-' + index + '-' + pIndex,\n                    controlType: 'number',\n                    required: true\n                  }\" [val]=\"actionPoint['point']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'point', index, pIndex)\"></column-number>\n                    <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n                    controlType: 'number'\n                  }\" [val]=\"actionPoint['point']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ng-template>\n              </ng-template>\n            </ul>\n          </dd>\n        </dl>\n      </div>\n    </div>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    RegistryPointComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: RegistryPointService }
    ]; };
    return RegistryPointComponent;
}(ContentBaseComponent));
export { RegistryPointComponent };
//# sourceMappingURL=registry-point.component.js.map